import { render, staticRenderFns } from "./DetailsRenderer.vue?vue&type=template&id=039c5268&scoped=true&"
import script from "./DetailsRenderer.vue?vue&type=script&lang=js&"
export * from "./DetailsRenderer.vue?vue&type=script&lang=js&"
import style0 from "./DetailsRenderer.vue?vue&type=style&index=0&id=039c5268&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "039c5268",
  null
  
)

/* custom blocks */
import block0 from "./DetailsRenderer.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports